import { DecisionContext, ProjectCompany, ProjectStatus } from "@/dbot/common/commonDomain";
import { makeAutoObservable } from "mobx";
import { DecisionType } from "@/common/decisions";

export type NoAuditor = {
  type: DecisionType.noAuditor;
};

export class NoAuditorForm {
  readonly type = DecisionType.noAuditor;
  readonly context: DecisionContext<NoAuditor>;

  constructor(context: DecisionContext<NoAuditor>) {
    makeAutoObservable(this, { type: false }, { autoBind: true });
    this.context = context;
  }

  private hasAuditor(orgNo: string): boolean {
    const auditor =
      this.context.contextData[orgNo]?.initialState?.company?.auditorCompanyOrganizationnumber;
    return (auditor ?? "").trim() !== "";
  }

  get companiesWithoutAuditor(): ProjectCompany[] {
    return this.context.companies.filter((c) => !this.hasAuditor(c.orgNo));
  }

  get allCompaniesHaveAuditor(): boolean {
    return (
      this.context.projectStatus !== ProjectStatus.DRAFT ||
      this.companiesWithoutAuditor.length === 0
    );
  }

  get isProjectLocked(): boolean {
    return this.context.isLocked;
  }
}
